import { render } from "./person-attachment.vue?vue&type=template&id=d9b78e2a"
import script from "./person-attachment.vue?vue&type=script&lang=js"
export * from "./person-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__